/**
 * Permission constants
 * Used for permission-based access control checks across frontend and backend
 */

export const PERMISSIONS = {
  ADMINISTER_AI: "administer_ai",
  ADMINISTER_USERS_CAMPAIGNS: "administer_users_campaigns",
  CORE_ACCESS: "core_access",
  EXTERNAL_REPORTS: "external_reports",
  FINANCIALS_ADMIN: "financials_admin",
  FINANCIALS_VIEW: "financials_view",
  /**
   * Reach the Data Sharing surface — what this firm shares with other firms, and the switch.
   *
   * Exists so that gate is a PERMISSION rather than a role-name match. `GRANT_AUDITOR` held zero
   * permissions and was admitted to `/grant-audit` by name, which is the one thing the role model
   * is meant to avoid. The role is still checked everywhere it SUBTRACTS access — permissions only
   * grant, so "this principal sees less than an ordinary member" cannot be expressed as one.
   */
  VIEW_DATA_SHARING: "view_data_sharing",
  /**
   * See claimant PII in the referring portal — names, contact details, documents. Held by every
   * ordinary role (granted by the 2026-09-24 data migration); NOT held by `funder`. PII is shown
   * only to a holder, so a role nobody configured gets the redacted portal, not the full one.
   */
  VIEW_PII: "view_pii",
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
